import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import { useNavigate } from "react-router";
import LoadingBoundary from "../../../../components/LoadingBoundary";
import RenderError from "../../../ErrorContainer";
import {
  SituationProfessionnelleFormData,
  situationProfessionnelleFormToModel,
} from "../helpers";
import AjouterSituationProfessionnelle, {
  validateForm,
} from "./AjouterSituationProfessionnelle";
import { useSituationProfessionnelle } from "./selectors";
import Snack from "../../../../components/Snack";

function SituationProfessionnellePage() {
  const {
    initialValues,
    ajouterSituationProfessionnelle,
    errorSituationPro,
    errorSituationProSecondaire,
    fetchingSituationPro,
    fetchingSituationProSecondaire,
    listSituationProfessionnelle,
    fetching,
    error,
    dossierLocation,
    resetSituationPro,
    resetSituationProSecondaire,
    isControleDossier,
    compositionLocation,
    selectedPerson,
    isCumulsUtilises,
    compositionLocationFormEnCours,
  } = useSituationProfessionnelle();

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/dossier-location/situation-personnelle");
  };

  // TODO VOIR SI CA MARCHE ?
  // const { pristine } = useFormState();
  const handleSubmit = (values: SituationProfessionnelleFormData) => {
    // if (values && !pristine) {
    if (values) {
      const situationProData =
        dossierLocation &&
        situationProfessionnelleFormToModel(
          values,
          dossierLocation,
          compositionLocationFormEnCours || compositionLocation
        );

      situationProData && ajouterSituationProfessionnelle(situationProData);
    } else {
      if (isControleDossier) {
        navigate("/dossier-location/pieces-justificatives");
      } else {
        // si le dossier a été créé par un partenaire qui ne souhaite pas de contrôle de PJ
        navigate("/dossier-location/synthese");
      }
    }
  };
  return (
    <LoadingBoundary loading={fetching} error={error}>
      <Form
        keepDirtyOnReinitialize
        name="situationProfessionnelleForm"
        initialValues={initialValues}
        validate={(values: SituationProfessionnelleFormData) =>
          dossierLocation &&
          dossierLocation.dossiersParticuliers &&
          validateForm(
            values,
            compositionLocation || compositionLocationFormEnCours,
            isCumulsUtilises
          )
        }
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit,
          pristine,
          submitting,
          errors,
          error,

          form: {
            mutators: { push, pop },
            change,
          },
          values,
        }) => (
          <AjouterSituationProfessionnelle
            change={change}
            listSituationProfessionnelle={listSituationProfessionnelle}
            initValues={initialValues}
            formValues={values}
            compositionLocation={
              compositionLocationFormEnCours || compositionLocation
            }
            selectedPerson={selectedPerson}
            dossierLocation={dossierLocation}
            onSubmit={handleSubmit}
            onPrecedent={handlePrecedent}
            isCumulsUtilises={isCumulsUtilises}
            situationProFetching={
              fetchingSituationPro || fetchingSituationProSecondaire
            }
          />
        )}
      </Form>

      <Grid container justifyContent="flex-end" style={{ marginTop: 12 }}>
        {(errorSituationPro || errorSituationProSecondaire) && (
          <RenderError
            errors={errorSituationPro || errorSituationProSecondaire}
            onClose={() => {
              resetSituationPro();
              resetSituationProSecondaire();
            }}
          />
        )}
      </Grid>
    </LoadingBoundary>
  );
}

export default SituationProfessionnellePage;
